var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.405036 45.9981C-0.366893 47.3314 0.595222 49.0002 2.13589 49.0002H53.8648C55.4054 49.0002 56.3675 47.3314 55.5956 45.9981L29.7312 1.32315C28.9608 -0.00741935 27.0398 -0.00741923 26.2695 1.32315L0.405036 45.9981ZM30.667 39.0002C30.667 40.1047 29.7716 41.0002 28.667 41.0002H27.3337C26.2291 41.0002 25.3337 40.1047 25.3337 39.0002V37.6668C25.3337 36.5623 26.2291 35.6668 27.3337 35.6668H28.667C29.7716 35.6668 30.667 36.5623 30.667 37.6668V39.0002ZM30.667 28.3335C30.667 29.4381 29.7716 30.3335 28.667 30.3335H27.3337C26.2291 30.3335 25.3337 29.4381 25.3337 28.3335V21.6668C25.3337 20.5623 26.2291 19.6668 27.3337 19.6668H28.667C29.7716 19.6668 30.667 20.5623 30.667 21.6668V28.3335Z",
    fill: "#D33E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.c6f25e3aaa597927f9e40b905e692a63.svg";
export { ForwardRef as ReactComponent };